import _, { omitBy, cloneDeepWith, get, isEmpty } from 'lodash';
import commonStore from '../store/commonStore.js';

interface IGlassboxEventObjec{
  EVENT_VALUE?: string;
  EVENT_NAME: string;
  EVENT_CATEGORY?: string;
  EVENT_ACTION?: string;
  ticker?: string;
  requestId?: string;
  sessionContext?: {
    authenticationType: string | undefined;
    deviceId: string;
    platformId: string;
    sessionId: string;
    vendorUserId: string | null;
    vendorUserType: string | null;
    cvUserId: string;
    crmUserId: string;
  };
  pageTrackingData?: {
    subPageId?: string;
    actionComponent?: string;
    eventType?: string;
    uiComponentId?: string;
    eventInstanceId?: string;
  };
}

interface IPiwikEventObject {
  customVariable: Array<
    | { properties: string | undefined }
    | { trackingSource?: string | undefined }
    | { menuCode?: string | undefined }
    | {
      someVar4?: string;
    }
    | null
    | null
    | { contentId?: string | undefined }
    | { contentSourceId?: string | undefined }
  >;
  trackingData: {
    loginId: string | undefined;
    idSite: string | undefined;
    menuNavigationPath: string | undefined;
  };
}
 
interface ISessionContext {
  authenticationType: string | undefined;
  deviceId: string;
  platformId: string;
  sessionId: string;
  vendorUserId: string | null;
  vendorUserType: string | null;
  cvUserId: string;
  crmUserId: string;
}

interface ISomevar4type {
  HLCC?: string;
  HLCN?: string;
  RenditionType?: string;
  authentication_id?: string;
  channel?: string;
  clickThruJson?: string;
  componentId?: string;
  componentName?: string;
  deviceId?: string;
  email_send_id?: string;
  eventId?: string;
  mode?: string;
  portalEnvironment?: string;
  prevEventInstanceId?: string;
  requestId?: string;
  sessionId?: string;
  subChannel?: string;
  userAgent?: string;
  totalPageLoadTime?: string;
  analystId?: string;
  ticker?: string;
  teamName?: string;
  eventCarouselId?: string;
  timeSpent?: string;
  campaignId?: string;
  figureId?: string;
  tagName?: string;
  userId?: string;
  childDocumentId?: string;
  pageNumber?: string;
  eventAction?: string;
  position?: string;
  section?: string;
  count?: string;
  eventInstanceId?: string;
  percentFromTop?: string;
  AnalystModelId?:string;
  sourceId?:string;
}

export const ReadershipTrackingService = {
  glassboxTracking: (data: IPiwikEventObject, eventAction: string | undefined | unknown, subPageId?: string | undefined, actionComponent?: string, crm_id?: string,eventData?:string,eventDType?:string, visibleComponentIdList?:any) => {
    const sessionContext: ISessionContext = commonStore.getState().asyncStateReducer.sessionContext.data.sessionContext;
    
    const someVar4Data: ISomevar4type = JSON.parse(get(data?.customVariable[3], 'someVar4') as unknown as string);
    const _HTML_RENDITION: any = commonStore.getState().asyncStateReducer.initialData;   
    const eventInstanceId:any =  someVar4Data.eventInstanceId
    const app = {
      SITE_ID: '70',
      CSI: '163778'
    };
    //glassbox structure json
    const sessionData = {
      platformId: _HTML_RENDITION.platform,
      cvUserId: (_HTML_RENDITION.partner_login != null ? _HTML_RENDITION.partner_login : _HTML_RENDITION.user_id),
      crmUserId: crm_id,
      vendorUserId: sessionContext?.vendorUserId,
      vendorUserType: sessionContext?.vendorUserType,
      deviceId: sessionContext?.deviceId,
      sessionId: sessionContext?.sessionId,
      authenticationType: sessionContext?.authenticationType,
      prevEventInstanceId: sessionStorage.getItem('prevEventInstanceId'),
      pageId: 'RENDITION_DOC',
      requestId: someVar4Data.requestId,
      vendorRequestId: _HTML_RENDITION.vendor_request_id,
      pageContextId: get(data?.customVariable[6], 'contentId'),
      pageContextType:'DOC_ID',
      eventInstanceId: someVar4Data.eventInstanceId,
      epochMillisec: Date.now(),
      appId: app.CSI,
    };

    // Exclude property with null or undefined value
    const sessionContextData = omitBy(
      sessionData,
      (value) => value === null || value === undefined
    );

    function replaceAll(str: string | undefined, find: string, replace: string) {
      let result = str;
      while (_.includes(result, find)) {
        result = result ? _.replace(result, find, replace) : '';
      }
      return result;
    }

    const { pageNumber, position, eventId, email_send_id, totalPageLoadTime, clickThruJson } = someVar4Data;
    const componentId = someVar4Data.componentName || get(data?.customVariable[2], 'menuCode');
    
    const uiComponentId = someVar4Data.componentName === 'HTML_DOCUMENT_OPEN'
      ? 'HTML_DOCUMENT_OPEN'
      : replaceAll(componentId?.toUpperCase(), " ", '_');
    const componentName = replaceAll(componentId?.toUpperCase(), " ", '_');
    const eventType = someVar4Data.eventAction ? someVar4Data.eventAction : (eventAction || 'CLICK');
    let eventDataId = '';
    let eventDataType = "";
    if (someVar4Data?.analystId) {
      eventDataId = someVar4Data?.analystId;
      eventDataType = 'ANALYST_ID';
    }

    if (someVar4Data?.ticker) {
      eventDataId = someVar4Data?.ticker;
      eventDataType = 'TICKER';
    }

    if (someVar4Data?.eventCarouselId) {
      eventDataId = someVar4Data?.eventCarouselId;
      eventDataType = 'EVENT_CAROUSEL_ID';
    }

    if (someVar4Data?.timeSpent) {
      eventDataId = someVar4Data?.timeSpent;
      eventDataType = 'TIME_SPENT';
    }

    if (someVar4Data?.campaignId) {
      eventDataId = someVar4Data?.campaignId;
      eventDataType = 'CAMPAIGN_ID';
    }

    if (someVar4Data?.userId) {
      eventDataId = someVar4Data?.userId;
      eventDataType = 'USER_ID';
    }

    if (someVar4Data?.childDocumentId) {
      eventDataId = someVar4Data?.childDocumentId;
      eventDataType = 'DOC_ID';
    }


    if (someVar4Data?.percentFromTop) {
      eventDataId = someVar4Data?.percentFromTop;
      eventDataType = 'SCROLL_PERCENTAGE';
    }
    if (someVar4Data?.AnalystModelId) {
      eventDataId = someVar4Data?.AnalystModelId;
      eventDataType = 'ANALYST_MODEL_ID';
    }
    if(!isEmpty(someVar4Data?.sourceId))
    {
      eventDataId =_HTML_RENDITION.parent_doc_id;
      eventDataType = 'DOC_ID';
    }

    try {
      console.log('Rendition Doc ReadershipTrackingService started !!');
      const customEventData = {
        pageLoadDurationMilliSec: totalPageLoadTime,
        emailSendId: email_send_id,
        pageNumber,
        uiComponentId: uiComponentId === 'HTML_DOCUMENT_OPEN'? null : uiComponentId,
        eventType,
        subPageId: replaceAll(subPageId?.toUpperCase(), " ", '_'),
        eventDataId: eventDataId ? eventDataId : eventData,
        eventDataType: eventDataType ? eventDataType : eventDType,
        eventDataPosition: position,
        visibleUIComponentIds:visibleComponentIdList,
      };
      let customParamData = omitBy(
        { ...sessionContextData, ...customEventData },
        (value) => !value || value === 'null' || value === null || value === undefined
      );
      if(window.HTML_RENDITION.isMultimediaPage){
        sessionData.pageId = 'RENDITION_MULTIMEDIA';
        customParamData.pageId = sessionData.pageId;
        customParamData.pageContextType = 'KALTURA_ENTRY_ID';
        customParamData.pageUrl = location.href;
        customParamData.pageLoadDurationMilliSec = window.HTML_RENDITION.totalMediaPageLoadTime;
        if(eventType !== 'PAGE_LOAD'){
          customParamData.uiComponentId = `${window.HTML_RENDITION.mediaTemplateCode?.toUpperCase()}_PLAY_BTN`;
        }
      }
      const EventData = {
        EVENT_ACTION: someVar4Data.eventAction ? someVar4Data.eventAction : (eventAction || 'CLICK'),
        EVENT_CATEGORY: sessionData.pageId,
        EVENT_VALUE: sessionData.pageId, // TAB
        CUSTOM_PARAM: customParamData,
        EVENT_TYPE: sessionData.pageId,
      };

      _.delay(()=>{if(window?.PORTAL && uiComponentId != 'RECORD_EVENTS' && uiComponentId != 'RECORD_TIMING') {
        console.log('uiComponenId:window.HTML_RENDITION.isMultimediaPage:', uiComponentId,window.HTML_RENDITION.isMultimediaPage);
        const tracker = window?.PORTAL?.UA.getEventTracker(app);
        console.log('Rendition Doc glasbox::', EventData)
        logFrontEndLoggers(EventData);
        tracker.triggerCustomEvent(sessionData.pageId, EventData);        
        sessionStorage?.setItem('prevEventInstanceId', eventInstanceId)
      }},3000);

      
      _.delay(()=>{
        if(window?.HTML_RENDITION?.isMultimediaPage && uiComponentId === 'HTML_DOCUMENT_OPEN') {
          console.log('uiComponenId:window.HTML_RENDITION.isMultimediaPage:', uiComponentId,window.HTML_RENDITION.isMultimediaPage);
          const tracker = window?.PORTAL?.UA.getEventTracker(app);
          console.log('kaltura page load glassbox::', EventData)
          logFrontEndLoggers(EventData);
          tracker.triggerCustomEvent(sessionData.pageId, EventData);          
          sessionStorage?.setItem('prevEventInstanceId', eventInstanceId)
        }},3000);
    } catch (e) {
      console.log('RENDITION-DOC-Exception while caling Glassbox CV API ' + e);
    }
  },
  };

const logFrontEndLoggers = (EventData: object) => {
  const ParsedData = cloneDeepWith(EventData, (value) => {
    try {
      return JSON.parse(value);
    } catch (error) {
      return undefined;
    }
  });
  const trackingData = JSON.stringify(ParsedData);
    fetch('/cvrservices/eppublic/frontEndLogger', {
    method: 'POST',
    body: trackingData,
  })
    .then((response) => {
      console.log('Success Responsive:' + response);
      commonStore.dispatch({ type: 'SET_PREVIOUS_REQUEST_ID', value: response.headers.get('x-citiportal-requestid') });
    })
    .catch((err) => {
      console.log('err:' + err);
    });
};
export default ReadershipTrackingService;
